import { Component } from '@angular/core';
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-content-section',
    templateUrl: './content-section.component.html',
    styleUrl: './content-section.component.scss',
    standalone: false
})
export class ContentSectionComponent {

  videoId: string = environment.VIDEO_ID;

}
